module.exports = __webpack_public_path__ + "res/0-img_wallet.0eb6f5d220f22d6308bf9cb70210bad6.png";